import { createStyles, makeStyles } from '@material-ui/core';

export default makeStyles((theme) =>
  createStyles({
    grid: {
      width: '100%',
    },
  }),
);
